import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import LoginPage     from './pages/LoginPage';
import FleetPage     from './pages/FleetPage';
import DevicePage    from './pages/DevicePage';
import EventsPage    from './pages/EventsPage';
import LivePage      from './pages/LivePage';
import OperatorsPage from './pages/OperatorsPage';
import SessionsPage  from './pages/SessionsPage';
import BreaksPage    from './pages/BreaksPage';
import LocationsPage from './pages/LocationsPage';
import RetentionPage from './pages/RetentionPage';
import AlarmConfigPage from './pages/AlarmConfigPage';
import SettingsPage  from './pages/SettingsPage';
import ReportsPage   from './pages/ReportsPage';
import PresencePage  from './pages/PresencePage';
import ShiftsPage    from './pages/ShiftsPage';
import VendorsPage   from './pages/VendorsPage';
import VendorFeaturesPage from './pages/VendorFeaturesPage';
import WorkActivityPage from './pages/WorkActivityPage';
import ActivityPolicyPage from './pages/ActivityPolicyPage';
import AppLayout     from './components/AppLayout';
import { useSSE }    from './hooks/useSSE';
import { TimezoneProvider } from './hooks/useTimezone';
import { UnsavedChangesProvider } from './hooks/useUnsavedChanges';

const theme = createTheme({
  palette: {
    primary:    { main: '#1976d2' },
    background: { default: '#f5f5f5' },
  },
  typography: { fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif' },
});

function ProtectedRoute() {
  const token = localStorage.getItem('access_token');
  if (!token) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function LayoutWrapper() {
  const { connected, reconnecting } = useSSE(null, null, null);
  return (
    <TimezoneProvider>
      <AppLayout sseConnected={connected} sseReconnecting={reconnecting} />
    </TimezoneProvider>
  );
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <UnsavedChangesProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<LayoutWrapper />}>
              <Route path="/"            element={<FleetPage />} />
              <Route path="/devices/:id" element={<DevicePage />} />
              <Route path="/events"      element={<EventsPage />} />
              <Route path="/live"        element={<LivePage />} />
              <Route path="/operators"   element={<OperatorsPage />} />
              <Route path="/sessions"    element={<SessionsPage />} />
              <Route path="/breaks"      element={<BreaksPage />} />
              <Route path="/reports"     element={<ReportsPage />} />
              <Route path="/presence"    element={<PresencePage />} />
              <Route path="/shifts"      element={<ShiftsPage />} />
              <Route path="/locations"   element={<LocationsPage />} />
              <Route path="/retention"   element={<RetentionPage />} />
              <Route path="/alarm-config" element={<AlarmConfigPage />} />
              <Route path="/work-activity" element={<WorkActivityPage />} />
              <Route path="/activity-policy" element={<ActivityPolicyPage />} />
              <Route path="/vendors"     element={<VendorsPage />} />
              <Route path="/vendor-features" element={<VendorFeaturesPage />} />
              <Route path="/settings"    element={<SettingsPage />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </UnsavedChangesProvider>
    </ThemeProvider>
  );
}
